(function($){



    var $window = $(window);
    var navbarMenu;
    var body;
    var navbarToggle;
    var heroSection = null;

    $(document).on( 'ready', startNavbar );
    $(window).on( 'load', startNavbarBgDetection );

    function startNavbar()
    {
        navbarMenu = $( '#navbar-menu' );
        body = $( 'body' );
        navbarToggle = $('.followme-top-navbar .navbar-toggler' );
        startNavbarToggle();

    }

    function startNavbarToggle()
    {
        navbarToggle.on( 'click', function() {
            navbarMenu.toggleClass( 'opened' );
        });
    }

    function startNavbarBgDetection()
    {
        heroSection = $('.followme-top-hero' );
        var isHero = heroSection.length ? true : false;

        let yOffset = $window.scrollTop();

        if ( yOffset > 0 ) {
            body.addClass( 'followme-scrolled-down' );
        } else {
            body.removeClass( 'followme-scrolled-down' );
        }

        $window.on("scroll", (evt) => {

            let yOffset = $window.scrollTop();

            if ( isHero ) {

                heroHeight = heroSection.height();
                if ( yOffset > 0 && yOffset <= heroHeight ) {
                    body.addClass( 'followme-scrolling-in-hero' );
                } else {
                    body.removeClass( 'followme-scrolling-in-hero' );
                }

                if ( yOffset > 0 && yOffset > heroHeight ) {
                    body.addClass( 'followme-scrolling-past-hero' );
                } else {
                    body.removeClass( 'followme-scrolling-past-hero' );
                }

            }

            if ( yOffset > 0 ) {
                body.addClass( 'followme-scrolled-down' );
            } else {
                body.removeClass( 'followme-scrolled-down' );
            }

        });

    }

})(jQuery);